import React from 'react'
import PageHeader from '../components/PageHeader'
import GallerySection from '../components/GallerySection'
import PriceBanner from '../components/PriceBanner'
import ContactForm from '../components/ContactForm'
import { COMPANY_INFO } from '../lib/constants'

export default function Designerlamper() {
  return (
    <div className="space-y-16">
      <PageHeader
        badge="Dansk Design & Æstetik"
        title="Montering af Danske Designerlamper"
        subtitle="Professionel ophængning, præcis justering og rådgivning om placering af eksklusive danske designerlamper til private og erhverv."
        breadcrumb="Designerlamper"
      />

      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-8 space-y-8">
            {/* Scrape text fidelity */}
            <div className="bg-white rounded-3xl border border-slate-200 p-8 sm:p-10 shadow-sm space-y-6">
              <div className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-[#55565C]">
                <span className="w-1.5 h-1.5 rounded-full bg-[#E36C0A]" aria-hidden="true" />
                <span>Eksklusiv belysning med håndværksmæssig præcision</span>
              </div>

              <h2 className="text-2xl sm:text-3xl font-extrabold text-slate-900 tracking-tight">
                Tilbud på danske designerlamper inkl. montage
              </h2>

              <div className="prose max-w-none text-slate-700 font-normal leading-relaxed space-y-4">
                <p className="text-base sm:text-lg font-normal text-slate-900">
                  Hvis dine lamper i højden inde som ude skal skiftes kan jeg give tilbud på danske designer lamper inkl. montage.
                </p>
                <p className="font-normal">
                  Danske designerlamper fortjener en montering, der matcher lampens kvalitet og design. En skæv baldakin, synlige kabler eller forkert ophængshøjde over spisebordet kan ødelægge helhedsindtrykket. Jakob sikrer, at dine lamper hænger i vater, med skjult ledningsføring og det rette lysfald i rummet.
                </p>
              </div>
            </div>

            {/* 4 Kerneydelser indenfor designerlamper */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              <div className="bg-white rounded-2xl p-6 border border-slate-200 shadow-sm space-y-3">
                <div className="w-10 h-10 rounded-xl bg-[#18191D] text-white flex items-center justify-center text-base">
                  <i className="fa-solid fa-ruler-combined text-xs" aria-hidden="true" />
                </div>
                <h3 className="font-bold text-slate-900 text-lg">
                  Hjælp til korrekt placering
                </h3>
                <p className="text-xs sm:text-sm text-[#55565C] leading-relaxed">
                  Rådgivning om optimal højde over spiseborde, køkkenøer, i trapperum og haller, så lampen hverken blænder eller skygger.
                </p>
              </div>

              <div className="bg-white rounded-2xl p-6 border border-slate-200 shadow-sm space-y-3">
                <div className="w-10 h-10 rounded-xl bg-[#18191D] text-white flex items-center justify-center text-base">
                  <i className="fa-solid fa-screwdriver-wrench text-xs" aria-hidden="true" />
                </div>
                <h3 className="font-bold text-slate-900 text-lg">
                  Professionel montering
                </h3>
                <p className="text-xs sm:text-sm text-[#55565C] leading-relaxed">
                  Skånsom fastgørelse i gipslofter, pudsede lofter og trælofter. Korrekt afkortning af stofledninger og fejlfri tilslutning.
                </p>
              </div>

              <div className="bg-white rounded-2xl p-6 border border-slate-200 shadow-sm space-y-3">
                <div className="w-10 h-10 rounded-xl bg-[#18191D] text-white flex items-center justify-center text-base">
                  <i className="fa-solid fa-tags text-xs" aria-hidden="true" />
                </div>
                <h3 className="font-bold text-slate-900 text-lg">
                  Tilbud på designerlamper
                </h3>
                <p className="text-xs sm:text-sm text-[#55565C] leading-relaxed">
                  Mulighed for at få samlet tilbud på udvalgte danske designklassikere og moderne arkitektonisk belysning inkl. levering og montering.
                </p>
              </div>

              <div className="bg-white rounded-2xl p-6 border border-slate-200 shadow-sm space-y-3">
                <div className="w-10 h-10 rounded-xl bg-[#18191D] text-white flex items-center justify-center text-base">
                  <i className="fa-solid fa-arrows-up-down text-xs" aria-hidden="true" />
                </div>
                <h3 className="font-bold text-slate-900 text-lg">
                  Lamper i stor højde
                </h3>
                <p className="text-xs sm:text-sm text-[#55565C] leading-relaxed">
                  Med egne lifte klarer Jakob ubesværet montering og pæreskift i store trappeopgange, haller og udendørs facadebelysning.
                </p>
              </div>
            </div>
          </div>

          {/* Sidebar */}
          <div className="lg:col-span-4 space-y-6">
            <div className="bg-gradient-to-br from-[#141628] via-[#1A1D37] to-[#121321] text-white rounded-3xl p-6 sm:p-8 shadow-xl border border-[#2D346E]/60 space-y-6">
              <div>
                <span className="inline-flex items-center gap-2 text-[11px] font-bold uppercase tracking-widest text-[#B5BBE8] mb-2 bg-[#252A6E]/50 border border-[#3C449E]/40 px-3 py-1 rounded-full">
                  <span className="w-1.5 h-1.5 rounded-full bg-[#E36C0A]" aria-hidden="true" />
                  <span>Direkte kontakt</span>
                </span>
                <h3 className="text-2xl font-extrabold tracking-tight text-white mt-1">
                  Få tilbud på lamper & montage
                </h3>
                <p className="text-[#9FA6D9] text-xs sm:text-sm mt-2 leading-relaxed">
                  Kontakt Jakob i dag for rådgivning eller et samlet uforpligtende tilbud på dine designerlamper.
                </p>
              </div>

              <a
                href={`tel:${COMPANY_INFO.phoneRaw}`}
                className="flex items-center justify-center gap-2.5 w-full rounded-full bg-[#E36C0A] hover:bg-[#B95000] text-white font-bold px-6 py-3.5 shadow-md transition-colors text-xs uppercase tracking-wider whitespace-nowrap"
              >
                <i className="fa-solid fa-phone text-xs" aria-hidden="true" />
                <span>Ring: {COMPANY_INFO.phone}</span>
              </a>

              <div className="pt-4 border-t border-[#2D346E]/60 space-y-2 text-xs text-[#9FA6D9]">
                <div className="flex items-center justify-between">
                  <span>Fast timepris:</span>
                  <strong className="text-white font-bold">485 kr. ex. moms</strong>
                </div>
                <div className="flex items-center justify-between">
                  <span>Servicevogn:</span>
                  <strong className="text-emerald-400 font-bold">Inkluderet</strong>
                </div>
                <div className="flex items-center justify-between">
                  <span>Opgaver i højden:</span>
                  <strong className="text-white font-bold">Egen lift til rådighed</strong>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Dynamic CMS Gallery for Designerlamper */}
        <GallerySection
          gallerySlug="designerlamper"
          title="Galleri: Designerlamper & Belysning"
          subtitle="Se eksempler på ophængning, placering og belysningsmiljøer i moderne boliger."
        />

        {/* Price Banner */}
        <PriceBanner compact={true} />

        {/* Contact Form Section */}
        <div className="my-12">
          <ContactForm />
        </div>
      </div>
    </div>
  )
}
